export default {
    data() {
        return {
            domNeedMove: [],
            scroller: {},
            startY: 0,
            endY: 0
        }
    },
    async mounted() {
        this.domNeedMove = document.querySelectorAll(
            ".el-select-dropdown.el-popper"
        );
        await this.$nextTick(()=>{
          this.scrollHanle
        });
        this.scroller = document.querySelector(".ps__rail-y");
    },
    methods: {
        scrollHanle(evt) {
            let dertaY = parseInt(this.scroller.style.top) - this.startY;
            this.domNeedMove.forEach(e => {
                let domNeedMoveY = parseInt(e.style.top);
                e.style.top = `${domNeedMoveY - dertaY}px`;
            });
            this.startY = parseInt(this.scroller.style.top);
        },
    }
}
